import { render, staticRenderFns } from "./campaign-layout.vue?vue&type=template&id=28fb2d52&scoped=true"
import script from "./campaign-layout.vue?vue&type=script&lang=js"
export * from "./campaign-layout.vue?vue&type=script&lang=js"
import style0 from "./campaign-layout.vue?vue&type=style&index=0&id=28fb2d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fb2d52",
  null
  
)

export default component.exports